<template>
	<div>
		<ul class="nav sub-nav documents-nav bd-b bd-2">
			<li class="nav-item">
				<a href="#all" data-toggle="tab" class="nav-link active">All</a>
			</li>
			<li class="nav-item">
				<a href="#general" data-toggle="tab" class="nav-link">General</a>
			</li>
			<li class="nav-item">
				<a href="#marketing" data-toggle="tab" class="nav-link">Marketing</a>
			</li>
			<li class="nav-item">
				<a href="#statements" data-toggle="tab" class="nav-link">Statements</a>
			</li>
		</ul>
		<div class="mg-t-20 mg-b-20 mg-lg-b-25 mg-xl-b-30">
			<div class="row">
				<div class="col-12">
					<div v-if="loading">
						<spinner-component :loading="loading"/>
					</div>

					<div v-if="error" class="tx-center tx-danger">
						{{ error }}
					</div>

					<!-- <div v-if="!documents && !loading" class="col-12">
						<h5 class="tx-color-01 mg-b-5 tx-center">Empty.</h5>
						<p class="tx-color-03 tx-13 tx-center">No Documents available at the moment.</p>
					</div> -->

					<div class="tab-content">
						<div class="tab-pane fade show active" id="all" role="tabpanel" aria-labelledby="all-tab">
							<documents-table-component :documents="documents"/>
						</div>
						<div class="tab-pane fade" id="general" role="tabpanel" aria-labelledby="general-tab">
							<documents-table-component :documents="filterDocuments('general')"/>
						</div>
						<div class="tab-pane fade" id="marketing" role="tabpanel" aria-labelledby="marketing-tab">
							<documents-table-component :documents="filterDocuments('marketing')"/>
						</div>
						<div class="tab-pane fade" id="statements" role="tabpanel" aria-labelledby="statements-tab">
							<a :href="`/statements/${company.external_client_id}/generate-pdf`" class="float-right btn btn-sm btn-default" target="_blank"><i data-feather="download"></i> Download Statement</a>
							<!-- <documents-table-component :documents="filterDocuments('statements')"/> -->
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
	.documents-nav .nav-item {
		margin: 0px 10px;
	}

	@media (max-width: 425px) {
		.documents-nav .nav-item {
			margin: 0px 0px;
		}
	}
</style>

<script>
import { mapGetters } from 'vuex';

	export default {
		data() {
			return {
				loading: false,
				documents: null,
				error: null,
			};
		},
		created() {
			this.fetchDocuments();
		},
		watch: {
			$route: "fetchDocuments",
		},
		computed: {
			...mapGetters({
				company: 'company',
			}),
		},
		methods: {
			filterDocuments(type) {
				return _.filter(this.documents, { type: type });
			},
			fetchDocuments() {
				this.error = this.documents = null;
				this.loading = true;

				axios
					.get("/api/documents", {
						params: {
							company: this.$store.getters.company.id,
						},
					})
					.then((response) => {
						const documents = response.data.data.documents.data;

						if (!_.isEmpty(documents)) {
							this.documents = documents;
						}
					})
					.catch((error) => {
						this.error = error.toString();
					})
					.finally(() => {
						this.loading = false;
					});
			},
		},
	};
</script>
